import type { Extent } from 'ol/extent';
import { createMap, MapCalculationMode, useMap, useVectorMapLayer } from '@common';
import type { VectorMapLayerGroup } from '@common';
import { useModulesConfigStore } from '../../../store';

export const useHeightmapWizardMap = () => {
  const moduleStore = useModulesConfigStore();

  const map = createMap({
    id: 'heightmapWizardMap',
    mapInfoEnabled: true,
    mapSourceUrl: moduleStore.moduleConfig.map.mapSourceURL,
    attributions: moduleStore.moduleConfig.map.attributions,
    calculationMode: MapCalculationMode.MERGED
  });

  const {
    layers,
    getLayer,
    addLayer,
    addSubLayer,
    enableZoneInteraction,
    disableZoneInteraction,
    fitExtentInView,
    clearLayers,
    switchSubLayer,
    fitMapExtentByLayers,
    removeLayer
  } = useMap(map);

  const zoomToExtent = (extent: Extent) => {
    fitExtentInView(extent);
  };

  const selectLayerByName = (layerName: string) => {
    layers.value.forEach((mapLayerGroup) => {
      const layer = mapLayerGroup.subLayers.find((subLayer) => subLayer.name === layerName);
      if (!layer) return;

      switchSubLayer(mapLayerGroup.id, layer.id);
    });
  };

  const onZoneSelect = (layerId: string, zoneId: string) => {
    const layer = getLayer(layerId) as any as VectorMapLayerGroup;
    if (!layer) return;

    const composedLayer = useVectorMapLayer(layer.activeSubLayer);
    composedLayer.selectZone(zoneId);
  };

  const onZoneDeselect = (layerId: string) => {
    const layer = getLayer(layerId) as any as VectorMapLayerGroup;
    if (!layer) return;

    const composedLayer = useVectorMapLayer(layer.activeSubLayer);
    composedLayer.deselectAllZones();
  };

  return {
    map,
    layers,
    enableZoneInteraction,
    disableZoneInteraction,
    zoomToExtent,
    getLayer,
    addLayer,
    clearLayers,
    selectLayerByName,
    onZoneSelect,
    onZoneDeselect,
    addSubLayer,
    fitMapExtentByLayers,
    removeLayer
  };
};
